export default {
  setDevice ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let isdevice = (payload !== undefined) ? payload : false
      commit('setDevice', isdevice)
      resolve()
    })
  },
  setWindowSize ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setWindowSize', payload)
      resolve()
    })
  },
  setWindowProgress ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setWindowProgress', payload)
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/viewport/actions.js